import { Injectable } from '@angular/core';
import { EventTrackerStrategyResource, EventType } from '@infra/trackers';

export interface IEventTrackerAction<
  Event = EventType,
  EventName = string,
  EventData = never,
  Output = void,
> {
  run(eventType: Event, eventName: EventName, eventData: EventData): Output;
}

@Injectable({
  providedIn: 'root',
})
export class EventTrackerAction implements IEventTrackerAction {
  constructor(private eventTrackerStrategy: EventTrackerStrategyResource) {
    this.initialize();
  }

  initialize() {
    this.eventTrackerStrategy.create('amplitude').init?.();
  }

  async run<T extends Partial<T>>(eventType: EventType, eventName: string, eventData?: T): Promise<void> {
    const strategy = this.eventTrackerStrategy.create(eventType);
    strategy.track(eventName, eventData);
  }
}
